<template>
    <section class="payroll-bases">
        <h2>Какие объекты считать базой</h2>
        <p class="text-muted">На выбранных объектах расчёт использует ставку сотрудника «База», на остальных — «Объекты». Настройка действует с указанного месяца; закрытая история сохраняется.</p>
        <div class="payroll-bases__filters">
            <label>Действует с месяца<b-form-input v-model="month" type="month" :disabled="saving || dirty" @change="load" /></label>
            <label>Найти действующий объект<b-form-input v-model="query" type="search" placeholder="Название объекта Argus" /></label>
        </div>
        <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
        <b-alert v-if="success" show variant="success">{{ success }}</b-alert>
        <div v-if="loading" role="status"><b-spinner small /> Загрузка объектов базы…</div>
        <template v-else-if="loaded">
            <p class="small text-muted">Выбрано: {{ selected.length }}. Список сохраняется кнопкой «Сохранить объекты базы».</p>
            <div class="payroll-bases__list">
                <b-form-checkbox v-for="object in filtered" :key="object.building_id" v-model="selected" :value="Number(object.building_id)" :disabled="saving">
                    {{ object.name }}
                </b-form-checkbox>
                <p v-if="!filtered.length" class="text-muted mb-0">Действующие объекты не найдены.</p>
            </div>
            <div v-if="inactiveAssigned.length" class="mt-3">
                <h3>Ранее выбранные неактивные объекты</h3>
                <p class="small text-muted">У этих объектов нет действующего процесса Argus. При необходимости снимите отметку базы; остальные назначения сохранятся.</p>
                <div class="payroll-bases__list">
                    <b-form-checkbox v-for="object in inactiveAssigned" :key="object.building_id" v-model="selected" :value="Number(object.building_id)" :disabled="saving">
                        {{ object.name }}
                    </b-form-checkbox>
                </div>
            </div>
            <div class="mt-3">
                <b-button variant="primary" :disabled="saving || !dirty" @click="save"><b-spinner v-if="saving" small /> Сохранить объекты базы</b-button>
                <b-button variant="outline-secondary" class="ml-2" :disabled="saving" @click="load">{{ dirty ? 'Сбросить изменения' : 'Обновить' }}</b-button>
            </div>
        </template>
    </section>
</template>
<script>
import api from '@/utils/api';
export default {
    name: 'TimesheetPayrollBases',
    props: {objects: {type: Array, default: () => []}},
    data() {
        const now = new Date();
        return {month: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`, selected: [], original: [], revision: '',
            query: '', loading: false, loaded: false, saving: false, error: '', success: '', version: 0};
    },
    computed: {
        dirty() { return JSON.stringify(this.selected.slice().sort((a, b) => a - b)) !== JSON.stringify(this.original); },
        filtered() {
            const query = this.query.toLocaleLowerCase('ru-RU').replace(/ё/g, 'е').trim();
            return this.objects.filter(row => row.is_active === true && String(row.name).toLocaleLowerCase('ru-RU').replace(/ё/g, 'е').includes(query))
                .slice().sort((a, b) => Number(this.selected.includes(Number(b.building_id))) - Number(this.selected.includes(Number(a.building_id)))
                    || String(a.name).localeCompare(String(b.name), 'ru'));
        },
        inactiveAssigned() {
            const byId = new Map(this.objects.map(row => [Number(row.building_id), row]));
            return Array.from(new Set(this.original.concat(this.selected))).map(id => byId.get(Number(id)) || {building_id: id, name: `Объект №${id}`})
                .filter(row => row.is_active !== true).sort((a, b) => String(a.name).localeCompare(String(b.name), 'ru'));
        }
    },
    mounted() { this.load(); },
    beforeDestroy() { this.version++; },
    methods: {
        accept(data) { this.selected = data.base_object_ids.slice(); this.original = data.base_object_ids.slice().sort((a, b) => a - b); this.revision = data.revision; },
        message(error) { return error && error.response && error.response.data && error.response.data.msg || 'Не удалось сохранить или загрузить объекты базы.'; },
        async load() {
            const version = ++this.version;
            this.loaded = false; this.loading = true; this.error = ''; this.success = '';
            try {
                const {data} = await api.get('/api/timesheets/settings/payroll-bases', {params: {period_start: `${this.month}-01`}, ignoreModal: true});
                if (version !== this.version) return;
                this.accept(data); this.loaded = true;
            } catch (error) { if (version === this.version) this.error = this.message(error); }
            finally { if (version === this.version) this.loading = false; }
        },
        async save() {
            this.saving = true; this.error = ''; this.success = '';
            try {
                const {data} = await api.put('/api/timesheets/settings/payroll-bases', {period_start: `${this.month}-01`,
                    base_object_ids: this.selected.slice(), expected_revision: this.revision}, {ignoreModal: true});
                this.accept(data); this.success = 'Объекты базы сохранены.';
            } catch (error) { this.error = this.message(error); }
            finally { this.saving = false; }
        }
    }
};
</script>
<style scoped>
.payroll-bases h2 { font-size: 1.2rem; }
.payroll-bases h3 { font-size: 1rem; }
.payroll-bases__filters { display: flex; flex-wrap: wrap; gap: 12px; }
.payroll-bases__filters label { min-width: 200px; }
.payroll-bases__list { display: grid; gap: 8px; max-height: 420px; overflow-y: auto; padding: 12px; border: 1px solid #ced4da; border-radius: .25rem; }
</style>
